import { MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { waLink } from "../lib/wa";
import { useSettings } from "../lib/settings";

const base =
  "inline-flex items-center justify-center gap-2 rounded-full font-semibold transition-all duration-300 cursor-pointer";
const variants = {
  solid: "bg-gold text-white hover:bg-gold-deep hover:-translate-y-0.5",
  outline: "border border-zinc-700 text-navy hover:border-gold hover:text-gold-deep",
  wa: "bg-[#1faf54] text-white hover:bg-[#189544] hover:-translate-y-0.5",
};
const sizes = {
  md: "px-6 py-3 text-sm",
  lg: "px-8 py-4 text-base",
};

export function WhatsAppButton({
  settings,
  message,
  children,
  className = "",
  testId,
  variant = "solid",
  size = "md",
}) {
  const href = waLink(settings, message);
  const cls = `${base} ${variants[variant]} ${sizes[size]} ${className}`;
  if (!href) {
    return (
      <button
        data-testid={testId}
        className={cls}
        onClick={() =>
          toast.info("Nomor WhatsApp perusahaan belum diatur.")
        }
      >
        <MessageCircle className="h-4 w-4" />
        {children}
      </button>
    );
  }
  return (
    <a data-testid={testId} href={href} target="_blank" rel="noopener noreferrer" className={cls}>
      <MessageCircle className="h-4 w-4" />
      {children}
    </a>
  );
}

export function WhatsAppFab() {
  const settings = useSettings();
  const message =
    "Halo Putra Bengawan Logistik, saya ingin bertanya tentang layanan angkutan/armada untuk kebutuhan proyek.";
  const href = waLink(settings, message);
  return (
    <button
      data-testid="wa-fab"
      aria-label="Hubungi via WhatsApp"
      onClick={() => {
        if (href) window.open(href, "_blank");
        else toast.info("Nomor WhatsApp perusahaan belum diatur.");
      }}
      className="fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#1faf54] text-white shadow-[0_8px_32px_rgba(0,0,0,0.5)] transition-transform duration-300 hover:scale-110"
    >
      <MessageCircle className="h-6 w-6" />
    </button>
  );
}
